const url = window.location.hostname
const host = window.location.protocol
const Conf = {
  HOST_S: url === 'localhost' ? 'https://' : host + '//',
  HOST: url === 'localhost' ? 'https://' : host + '//',
  CORE_IP: url === 'localhost' ? '64.227.140.206' : url,
  CORE_IP2: url === 'localhost' ? '64.227.140.206' : url,
  CORE_IP3: url === 'localhost' ? '64.227.140.206' : url,
  // CORE_IP2: '64.227.140.206',
  LC_IP: url === 'localhost' ? '64.227.140.206' : url,
  PORT_1: url === 'localhost' ? '' : '',
  PORT_2: url === 'localhost' ? '' : '',
  PORT_3: url === 'localhost' ? '' : '',
  PORT_4: url === 'localhost' ? '' : '',
  UNET_IP: url === 'localhost' ? '64.227.140.206' : url,
  parserIP: url === 'localhost' ? '64.227.140.206' : url,
}
export default Conf
